module.exports = __webpack_public_path__ + "img/main-logo.1825cf9c.svg";